import { getFlatTitle } from './getFlatTitle';
import { getShortCategory } from '../category/getShortCategory';

import type { IOffer } from 'shared/offer';

export function getOfferCategoryTitle(offer: IOffer): string | undefined {
  switch (getShortCategory(offer.category || '')) {
    case 'flat':
    case 'newBuildingFlat':
    case 'dailyFlat':
      return getFlatTitle(offer);
    default:
      return undefined;
  }
}
